export namespace NBulkOrder {
    /**
     * Source category for bulk orders
     */
    export const BULK_CATEGORY_ID = 312;
    /**
     * Bulk block url
     */
    export const BULK_BLOCK_URL = '/bulk-order';
    /**
     * Bulko cms block contents
     */
    export interface IBulkOrderBlockContent {
        /**
         * Top title
         */
        title?: string;
        /**
         * Top copy under title
         */
        intro?: string;
        /**
         * Importer title
         */
        importerTitle?: string;
        /**
         * Importer copy under title (excep for the download copy)
         */
        impoterIntro?: string;
        /**
         * Importer sample download copy
         */
        impoterDownloadCopy: string;
    }
}
